<div class="step-search">
  <div class="step-search__subtitle">
    Escolha um usuário para duplicar; o novo acesso inclui os mesmos produtos.
  </div>

  <form class="step-search__form" [formGroup]="searchCloneableLogonForm">
    @if (hasError && !isTooManyResultsError) {
      <pl-alert color="error" display="block">
        <span header>{{ errorMessage?.title }}</span>
        <span content>
          {{ errorMessage?.description }}
        </span>
      </pl-alert>
    }

    <div class="step-search__form__input-container">
      <seds-search
        class="step-search__form__input search-form-input--with-actions"
        [ngClass]="{
          'search-form-input--error': inputError || isTooManyResultsError,
        }"
        [color]="inputError || isTooManyResultsError ? 'error' : undefined"
        label="Pesquise por nome, e-mail ou logon"
        (search)="onSearchSubmit($event)"
        (keyup)="onSearchInput($event)"
      ></seds-search>

      @if (!searchSubmitted) {
        <button
          class="search-button"
          type="button"
          aria-label="Pesquisar"
          [disabled]="searchResultsLoading"
          (click)="onSearchButtonClick()"
        >
          <mat-icon fontSet="material-icons">search</mat-icon>
        </button>
      }

      @if (searchSubmitted) {
        <button
          class="clear-button"
          type="button"
          (click)="clearSearch()"
          aria-label="Limpar busca"
        >
          <mat-icon fontSet="material-icons">clear</mat-icon>
        </button>
      }
    </div>

    @if (isTooManyResultsError) {
      <div class="error-message">
        <mat-icon fontSet="material-icons" class="error-icon">error</mat-icon>
        <span>{{ tooManyResultsInlineMessage }}</span>
      </div>
    }

    @if (searchResultsLoading) {
      <div class="loading-container">
        <seds-loaders-bar style="width: 100%"></seds-loaders-bar>
        <span>Aguarde enquanto buscamos os usuários.</span>
      </div>
    }

    @if (!searchResultsLoading && searchResults.length > 0) {
      <ul class="step-search__results" role="listbox" aria-label="Resultados da busca">
        @for (item of searchResults; track item.logon) {
          <li
            class="step-search__results__item"
            [class.step-search__results__item--selected]="isSelected(item)"
            role="option"
            [attr.aria-selected]="isSelected(item)"
            (click)="onSelectionChanged(item)"
          >
            <p class="step-search__results__label">{{ item?.name }}</p>
            <p class="step-search__results__label">{{ item?.displaySubLabel }}</p>
            @if (isSelected(item)) {
              <i class="material-icons-round step-search__results__check">check</i>
            }
          </li>
        }
      </ul>
    }
  </form>
</div>
